// ==========================================================================
// Cookies
// ==========================================================================

// Get cookie details if exists
var getCookie = function(name) {
  var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
};

// Create a new cookie for one year
var setCookie = function(key, value) {
    var expiration_date = new Date();
    var cookie_string = '';
    expiration_date.setFullYear(expiration_date.getFullYear() + 1);
    cookie_string = key + '='+ value +'; path=/; expires=' + expiration_date.toGMTString();
    document.cookie = cookie_string;
};



// WEBPACK FOOTER //
// ./src/js/modules/_cookies.js